var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "i-select",
    {
      ref: "select",
      staticClass: "ivu-auto-complete",
      attrs: {
        label: _vm.label,
        disabled: _vm.itemDisabled,
        clearable: _vm.clearable,
        placeholder: _vm.placeholder,
        size: _vm.size,
        placement: _vm.placement,
        value: _vm.currentValue,
        "transfer-class-name": _vm.transferClassName,
        filterable: "",
        remote: "",
        "auto-complete": "",
        "remote-method": _vm.remoteMethod,
        transfer: _vm.transfer,
        capture: _vm.capture,
        eventsEnabled: _vm.eventsEnabled
      },
      on: {
        "on-select": _vm.handleSelect,
        "on-clickoutside": _vm.handleClickOutside
      }
    },
    [
      _vm._t("input", function() {
        return [
          _c("i-input", {
            ref: "input",
            attrs: {
              slot: "input",
              "element-id": _vm.elementId,
              name: _vm.name,
              placeholder: _vm.placeholder,
              disabled: _vm.itemDisabled,
              size: _vm.size,
              icon: _vm.inputIcon
            },
            on: {
              "on-click": _vm.handleClear,
              "on-focus": _vm.handleFocus,
              "on-blur": _vm.handleBlur
            },
            slot: "input",
            model: {
              value: _vm.currentValue,
              callback: function($$v) {
                _vm.currentValue = $$v
              },
              expression: "currentValue"
            }
          })
        ]
      }),
      _vm._v(" "),
      _vm._t("default", function() {
        return _vm._l(_vm.filteredData, function(item) {
          return _c("i-option", { key: item, attrs: { value: item } }, [
            _vm._v(_vm._s(item))
          ])
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b444816", { render: render, staticRenderFns: staticRenderFns })
  }
}